<template>
  <div
    class="web-about"
    :style="{
      backgroundImage: 'url(' + dataInfo.cover + ')'
    }"
  >
    <div class="g-box">
      <div class="about-title">
        <div class="tt">ABOUT US</div>
        <div class="tit">关于我们</div>
      </div>
      <div class="about-con">
        <div class="con-le">
          <div class="t1">
            华博特是一家浙江领先的教育科技公司，用创新的教育理念和先进的服务标准提升全国各地人民的知识、技能水平
          </div>
          <div style="margin-top:16px">
            华博特教育集团创立于2009年，公司一直秉承”让学习成为习惯”的宗旨，参与了中国继续教育十多年来的改革与发展。我们的教育服务涵盖全国10余个省份，助力200万+学员持续学习与发展，帮助他们追寻更广阔的人生。
          </div>
          <div>
            我们提供一系列的学历和职业技能提升服务，支持所有有梦想的人，在人生路上更进一步
          </div>
          <div style="margin-top:16px">
            我们连结高等院校和头部企业，专注于培养适应新时代发展要求的高技能职业化人才符合地区经济发展趋势，创造更大的社会价值
          </div>
          <div class="about-more" @click="toDetail">了解更多 ></div>
        </div>
        <div class="con-ri">
          <img :src="contentInfo.image" alt="" class="img" />
        </div>
      </div>
      <div class="about-nums">
        <div class="item">
          <div class="value">10+</div>
          <div class="label">职业教育合作办学</div>
        </div>
        <div class="item">
          <div class="value">40+</div>
          <div class="label">成人教育合作院校</div>
        </div>
        <div class="item">
          <div class="value">1200+</div>
          <div class="label">合作企业</div>
        </div>
        <div class="item">
          <div class="value">5W+</div>
          <div class="label">成人教育在读学生</div>
        </div>
        <div class="item">
          <div class="value">10W+</div>
          <div class="label">就业输送</div>
        </div>
        <div class="item">
          <div class="value">30W+</div>
          <div class="label">累计招生</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {},
      contentInfo: {},
      banner: {}
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: {},
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);
    const data = await this.getMenuList({
      pageNum: 1,
      pageSize: 1,
      menuId: this.menuId
    });
    this.contentInfo = data[0];
    this.dataInfo = dataInfo;
  },
  methods: {
    toDetail() {
      this.toUrl(this.contentInfo.url);
    }
  }
};
</script>
<style lang="less">
.web-about {
  padding-top: 96px;
  width: 100%;
  height: 860px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-sizing: border-box;
  .about {
    &-title {
      .tt {
        font-size: 60px;
        font-family: "en-tit";
        line-height: 72px;
        color: rgba(255, 255, 255, 0);
        -webkit-text-stroke: 1px #fff;
        text-stroke: 1px #fff;
      }
      .tit {
        font-size: 40px;
        font-family: Dream-LiHeiGB, Dream;
        color: #fff;
        line-height: 45px;
      }
    }
    &-con {
      display: flex;
      justify-content: space-between;
      .con-le {
        width: 600px;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
        .t1 {
          margin-top: 40px;
          font-size: 16px;
          font-weight: 600;
        }
      }
      .con-ri {
        padding-top: 40px;
        .img {
          width: 521px;
          height: 337px;
        }
      }
    }
    &-more {
      margin-top: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #fff;
      width: 130px;
      height: 44px;
      border-radius: 2px;
      border: 1px solid #fff;
      cursor: pointer;
    }
    &-nums {
      margin-top: 80px;
      display: flex;
      align-items: center;
      .item {
        width: 200px;
        .label {
          padding-top: 10px;
          font-size: 14px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.6);
          line-height: 20px;
        }
        .value {
          font-size: 36px;
          font-family: Roboto-Black, Roboto;
          font-weight: 900;
          color: #fff;
          line-height: 42px;
        }
      }
    }
  }
}
</style>
